import { summarizeUsage } from '@/shared/lib/pod-usage';
import { Card } from '@/shared/ui/card';
import { Meter } from '@/shared/ui/meter';
import { usageNote } from '../model/billing-status';
import type { WorkspaceData } from '../types';

export function UsageCard({ workspace }: { workspace: WorkspaceData }) {
  const usage = summarizeUsage(workspace.usage);
  return (
    <Card asChild>
      <section data-enter="" aria-labelledby="use-h" className="flex flex-col gap-3 p-5">
        <h2 id="use-h" className="font-semibold text-section">
          {usage.label}
        </h2>
        <span className="font-semibold text-figure tabular-nums">
          {usage.used}{' '}
          <small className="font-medium text-muted text-section tracking-normal">
            of {usage.limit}
          </small>
        </span>
        <Meter ratio={usage.ratio} tone={usage.meterTone} label={usage.label} />
        <p className="text-muted">{usageNote(workspace)}</p>
        <p className="text-meta text-muted">
          One Pod running for one hour is one Pod-hour, metered per second. Agents in the same Pod
          share it, and a Pod stops 10 minutes after its last session.
        </p>
      </section>
    </Card>
  );
}
